import { memo, useMemo, useState } from 'react';
import { BsDot } from 'react-icons/bs';
import { HiOutlineExternalLink } from 'react-icons/hi';
import { IoBusinessOutline } from 'react-icons/io5';
import {
  SUITABLE_TEXT_LENGTH,
  SUITABLE_TEXT_MAX_LENGTH,
  SUITABLE_TEXT_MAX_LINE,
  SUITABLE_TEXT_MAX_WIDTH,
} from '../../../../constant/user-setting-modal-resources';
import {
  checkStringNeedToBeSeeMore,
  numberOfNewLine,
  renderNewStringWithNewLine,
} from '../../../../helpers/stringHelpers';
import { parseTimeWithMonth } from '../../../../helpers/timeHelpers';
import {
  IDetailProfileInfoFC as IProjectModal,
  UserSettingEnum,
} from '../../../../interfaces/profile.interface';
import ProfileInfoEditButton from '../button/ProfileInfoEditButton';

const Project: React.FC<IProjectModal> = ({ data, roleView, setModal }) => {
  const [seeMore, setSeeMore] = useState<boolean>(false);
  const item = useMemo(() => data, [data]);

  return (
    <div className="group flex justify-between items-start">
      <span className="mt-2">
        <div className="bg-blur_primary rounded-full p-2">
          <IoBusinessOutline className="text-primary text-[16px]" />
        </div>
      </span>
      <div className="w-full mx-4 overflow-hidden">
        <p className="text-primary_black text-[16px] break-words">
          {item.projectName}
        </p>
        <p className="text-primary_black text-[14px] break-words">
          {item.position}
        </p>
        <p className="text-[#979797] text-[12px] break-words flex justify-start items-center gap-[1px]">
          {item.startDate && parseTimeWithMonth(item.startDate, item.endDate)}
          <BsDot size={10} />
          {item.numberOfMembers && item.numberOfMembers + ' thành viên'}
        </p>
        {item.description && (
          <p className="text-[#979797] text-[14px] w-full mt-2 mb-5">
            <span className="break-words">
              {!seeMore &&
              checkStringNeedToBeSeeMore(
                item.description,
                SUITABLE_TEXT_MAX_LENGTH,
                SUITABLE_TEXT_MAX_WIDTH
              )
                ? `${
                    numberOfNewLine(item.description) === 1
                      ? item.description?.substring(0, SUITABLE_TEXT_LENGTH)
                      : renderNewStringWithNewLine(
                          item.description,
                          SUITABLE_TEXT_MAX_LINE,
                          SUITABLE_TEXT_MAX_WIDTH
                        )
                  }...`
                : item.description}
            </span>
          </p>
        )}

        {item.mission && (
          <p className="text-[#333333] text-[14px] w-full">
            <span className="break-words">
              {!seeMore &&
              checkStringNeedToBeSeeMore(
                item.mission,
                SUITABLE_TEXT_MAX_LENGTH,
                SUITABLE_TEXT_MAX_WIDTH
              )
                ? `${
                    numberOfNewLine(item.mission) === 1
                      ? item.mission?.substring(0, SUITABLE_TEXT_LENGTH)
                      : renderNewStringWithNewLine(
                          item.mission,
                          SUITABLE_TEXT_MAX_LINE,
                          SUITABLE_TEXT_MAX_WIDTH
                        )
                  }`
                : item.mission}
            </span>
            {!seeMore &&
              (checkStringNeedToBeSeeMore(
                item.mission,
                SUITABLE_TEXT_MAX_LENGTH,
                SUITABLE_TEXT_MAX_WIDTH
              ) ||
                checkStringNeedToBeSeeMore(
                  item.description,
                  SUITABLE_TEXT_MAX_LENGTH,
                  SUITABLE_TEXT_MAX_WIDTH
                )) && (
                <span
                  onClick={() => {
                    setSeeMore(true);
                  }}
                  className="text-primary hover:underline cursor-pointer inline-block"
                >
                  ...xem thêm
                </span>
              )}
          </p>
        )}
        {/* prefect page */}
        {item.link && (
          <a
            href={item.link}
            target="_blank"
            rel="noreferrer"
            className="border mt-2 w-fit border-primary rounded-xl text-primary flex items-center gap-2 px-3 py-1"
          >
            <span>Liên kết</span>
            <HiOutlineExternalLink size={20} />
          </a>
        )}
      </div>
      <div className="block lg:hidden group-hover:block">
        <ProfileInfoEditButton
          value={item}
          roleView={roleView}
          modalName={UserSettingEnum.Project}
          setModal={setModal}
        />
      </div>
    </div>
  );
};

export default memo(Project);
